import { useEffect, type FC } from "react";
import { Outlet } from "react-router-dom";

import { useHidePylonChat } from "@/hooks/use-boot-in-app-chat";
import { preloadAutomationsRouteModules } from "@/routes/automations/AutomationsRouteElements";

/**
 * Layout wrapper for all automation routes. Hides the Pylon chat bubble
 * so it stays hidden when navigating between automation sub-pages.
 */
export const AutomationsLayout: FC = () => {
    useHidePylonChat();

    useEffect(() => {
        const browserWindow = window as Window & {
            requestIdleCallback?: (callback: () => void) => number;
            cancelIdleCallback?: (handle: number) => void;
        };
        const preload = () => {
            void preloadAutomationsRouteModules();
        };

        if (browserWindow.requestIdleCallback) {
            const handle = browserWindow.requestIdleCallback(preload);
            return () => browserWindow.cancelIdleCallback?.(handle);
        }

        const timeout = browserWindow.setTimeout(preload, 0);
        return () => browserWindow.clearTimeout(timeout);
    }, []);

    return <Outlet />;
};
